import { Action, Dispatch, MiddlewareAPI } from "redux";
import axios, { isAxiosError } from "axios";

import { customerIdMismatch } from "./actions";

export const validateCustomerIdMiddleware = (api: MiddlewareAPI<Dispatch, any>) => (next: Dispatch) => async (action: Action) => {

    try {
        if (api.getState()?.currentUser?.currentCustomer?.id) {
            axios.defaults.headers.common.Customer_Id = api.getState().currentUser.currentCustomer.id;
        }

        return await next(action);
    } catch (axiosError) {

        if (isAxiosError(axiosError)
            && axiosError?.response?.data
            && axiosError.response.status === 409 // 400 is handled by many http requests, so cannot be used
            && "error" in axiosError.response.data
            && typeof axiosError.response.data.error === "string"
            && axiosError.response.data.error === "CustomerIdMismatch") {

            api.dispatch(customerIdMismatch());
            return null;
        }

        throw axiosError;
    }
};
